
import { defineComponent } from "vue";
import { get, startCase } from "lodash-es";
import { IJbaScoreCount } from "@/types";

export default defineComponent({
  name: "FloodRisks",
  props: {
    jbaScoreCounts: {
      type: Array as () => IJbaScoreCount[],
      required: true,
    },
  },
  data: () => ({
    summaryFields: [
      "CombinedScore",
      { key: "Level", label: "RAG Level" },
      { key: "Description", label: "RAG Description" },
      { key: "Color", label: "RAG Color" },
    ],
    jbaScoreFields: [
      { key: "BandDepth", label: "Depth" },
      { key: "Layer.Year", label: "Year" },
      { key: "Score", label: "Score" },
    ],
    floodRiskTypes: [
      ["Coastal", require("@/assets/icons/coastal.svg")],
      ["River", require("@/assets/icons/river.svg")],
      ["SurfaceWater", require("@/assets/icons/surfaceWater.svg")],
    ],
    tabIndex: 0,
  }),
  watch: {
    jbaScoreCounts: {
      handler() {
        this.tabIndex = this.floodRiskTypes
          .map((type) => this.score(type[0]))
          .reduce((acc, item, key) => {
            if (item > this.score(this.floodRiskTypes[acc][0])) {
              return key;
            }
            return acc;
          }, 0);
      },
      immediate: true,
    },
  },
  methods: {
    startCase,
    riskData(name: string) {
      return this.jbaScoreCounts.filter(
        (i: IJbaScoreCount) => get(i, "Layer.Name") === name
      );
    },
    score(name: string) {
      return this.riskData(name)
        .map((rows) => rows.Score)
        .reduce((a, b) => Math.max(a, b), 0);
    },
    rowClass(row: IJbaScoreCount) {
      return row.Score ? "bg-light text-danger" : "";
    },
  },
});
